module.exports = __webpack_public_path__ + "static/elsaM_screen05-56f4dff79fbe15c6d1e9cab397432b31.jpg";